import * as React from 'react'

import { SVGResponsive } from './common'

function Logo() {
  return (
    <SVGResponsive height={22} width={19}>
      <path fill="#28325A" d="M3 9h13v13H3z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M16 22H3V9l13 13z" fill="#FFBD33" />
      <path d="M9.5 0L19 9H0l9.5-9z" fill="#5196CB" />
    </SVGResponsive>
  )
}

export default React.memo(Logo)
